import React from 'react';

const SEP = /[\s\-._/]/;

export const normalizeSearch = (s) => String(s || '').toLowerCase().replace(/[\s\-._/]/g, '');

export const searchTokens = (term) => {
  const words = String(term || '').toLowerCase().split(/\s+/).filter(Boolean).map(normalizeSearch).filter(Boolean);
  const compact = normalizeSearch(term);
  return [...new Set([compact, ...words].filter(Boolean))].sort((a, b) => b.length - a.length);
};

export const matchesTokens = (text, tokens) => {
  const n = normalizeSearch(text);
  return !!n && tokens.some(t => n.includes(t));
};

export const SearchHighlight = ({ text, tokens = [], className = '' }) => {
  const str = String(text ?? '');
  if (!tokens.length || !str) return <>{str}</>;
  const map = [];
  let norm = '';
  for (let i = 0; i < str.length; i++) {
    if (SEP.test(str[i])) continue;
    norm += str[i].toLowerCase();
    map.push(i);
  }
  const marked = new Array(str.length).fill(false);
  tokens.forEach(t => {
    let from = 0;
    let idx;
    while ((idx = norm.indexOf(t, from)) !== -1) {
      const start = map[idx];
      const end = map[idx + t.length - 1];
      for (let i = start; i <= end; i++) marked[i] = true;
      from = idx + 1;
    }
  });
  if (!marked.some(Boolean)) return <>{str}</>;
  const parts = [];
  let i = 0;
  while (i < str.length) {
    const flag = marked[i];
    let j = i;
    while (j < str.length && marked[j] === flag) j++;
    const chunk = str.slice(i, j);
    parts.push(flag
      ? <mark key={i} className={`bg-yellow-200 text-gray-900 rounded-sm px-0.5 ${className}`} data-testid="search-highlight">{chunk}</mark>
      : <React.Fragment key={i}>{chunk}</React.Fragment>);
    i = j;
  }
  return <>{parts}</>;
};
